{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Hacker plan allows only 2 agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Account settings",
    "SUBMIT": "Update settings",
    "BACK": "Back",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Could not update settings, try again!",
      "SUCCESS": "Successfully updated account settings"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Delete",
        "DISMISS": "Cancel",
        "PLACE_HOLDER": "Please type {accountName} to confirm"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Please fix form errors",
      "GENERAL_SECTION": {
        "TITLE": "General settings",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "Account name",
        "PLACEHOLDER": "Your account name",
        "ERROR": "Please enter a valid account name"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Your account name",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "The domain where you will receive the emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support Email",
        "PLACEHOLDER": "Your company's support email",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Number of hours after a conversation should auto resolve if there is no activity",
        "NOTE": "Number of inactivity hours after which any open conversation will be auto-resolved.",
        "PLACEHOLDER": "never",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 hour and maximum 23976 hours)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Number of days after an empty conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "never",
        "ERROR": "Please enter a valid auto resolve empty duration (minimum 1 day and maximum 999 days)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Conversation continuity with emails is enabled for your account.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "You can receive emails in your custom domain now."
      },
      "PHONE": {
        "TITLE": "PBX Settings",
        "NOTE": "Configure connection to your PBX for phone calls",
        "SIP_HOST": {
          "LABEL": "SIP domain"
        },
        "DIALING_MODE": {
          "LABEL": "Dialing mode",
          "MODES": {
            "direct": "Direct - call is immediately dialed when clicking phone link",
            "indirect": "Indirect - phone number is prepared in phone widget entry box"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Call recording access",
          "MODES": {
            "admin_only": "Administrators only",
            "admin_and_assigned_agent": "Administrators and assigned agent",
            "inbox_members": "All agents with inbox access"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Email Settings",
        "NOTE": "Modifies the behavior of email inboxes"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Conversation timestamp display mode",
        "MODES": {
          "both": "Created and last activity",
          "last_activity_only": "Only last activity",
          "last_customer_message": "Last customer message"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Block domains with low reputation"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Include original message in response to the email"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automatically resolve a new conversation"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automatically move a new email conversation to the inbox of the robot that processed the contact's orders"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Extended labels - Allow longer label names with larger popup interface"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Auto assign conversation to the agent who created last answer"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Push notification mode",
        "MODES": {
          "all_inboxes": "All inboxes - Send notifications for all channel types",
          "chat_only": "Chat only - Only send notifications for non-email channels"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Allow toggle signature on sent messages"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Display agent chat status on wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Show full attachment names without truncation"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Password login",
        "MODES": {
          "allowed_for_all": "Allowed for all users",
          "allowed_for_agents_only": "Allowed for agents only (admins must use OAuth)",
          "password_login_disabled": "Disabled - OAuth only"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "A new version available. Reload to get the latest updates.",
    "RELOAD_NOW": "Update now",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Your payment is pending. Please update your payment information to continue using this software",
    "LIMITS_UPGRADE": "Your account has exceeded the usage limits, please upgrade your plan to continue using this software",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Press enter to select",
      "ENTER_TO_REMOVE": "Press enter to remove",
      "NO_OPTIONS": "List is empty",
      "NO_RESULT": "No results found",
      "SELECT_ONE": "Select one",
      "SELECT": "Select"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Mark All Done",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Loading notifications...",
      "404": "No Notifications",
      "TABLE_HEADER": [
        "Name",
        "Phone Number",
        "Conversations",
        "Last Contacted"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "New conversation",
      "conversation_assignment": "Conversation Assigned",
      "assigned_conversation_new_message": "New Message",
      "participating_conversation_new_message": "New Message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Connection lost",
      "DESCRIPTION": "We couldn't reach the server. Check your connection and try again.",
      "RETRY": "Try again"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Reports",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "EXECUTE_MACRO": "Execute Macro",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Settings",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Execute a macro",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click here"
  }
}